import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { CART_UPDATE_STOCK, WORK_DAY_FIND_SUCCESS } from '@store/actions';
import { MenuItemUpsert } from '@core/models/menu-item/menu-item';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private socket: Socket | null = null;
  stockUpdates = new BehaviorSubject<null>(null);

  constructor(
    private store: Store
  ) { }

  connect(token: string, localCanalId: string): void {
    if (this.socket && this.socket.connected) {
      return;
    }

    if (this.socket) {
      this.socket.disconnect();
    }

    this.socket = io(environment.socket, {
      transports: ['websocket'],
      query: {
        token,
        localCanalId,
      },
      auth: {
        token,
        localCanalId,
      },
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
    });

    this.setupSocketListeners();
  }

  private setupSocketListeners(): void {
    if (!this.socket) return;

    // Escucha eventos de conexión
    this.socket.on('connect', () => {
    });

    // Escucha actualizaciones de stock
    this.socket.on('notify-stock', (data: MenuItemUpsert) => {
      this.store.dispatch(CART_UPDATE_STOCK({ updateProduct: data }));
      // this.stockUpdates.next(data);
    });

    this.socket.on('close-day', (data: unknown) => {
      this.store.dispatch(WORK_DAY_FIND_SUCCESS({ workDay: null }));
    });

    // Escucha desconexión
    this.socket.on('disconnect', (reason: string) => {
    });

    this.socket.on('connect_error', (error: Error) => {
      console.warn('WebSocket connection error:', error?.message || error);
    });
  }

  // Expone los updates de stock como Observable
  getStockUpdates(): Observable<null> {
    return this.stockUpdates.asObservable();
  }

  // Método para desconectar manualmente
  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}
